
import type { BaseErrorResponse, GetEntitiesRes, GetEntityInfoRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { HttpClient } from './http-client';


export default function useEntityInfo() {
  class EntityInfo<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Entity
     * @name EntityControllerGetEntities
     * @summary Returns available entity names
     * @request GET:/api3/entity-info
     * @secure
     * @response `200` `GetEntitiesRes`
     * @response `400` `BaseErrorResponse`
     */
    entityControllerGetEntities = (params: RequestParams = {}) =>
      this.request<GetEntitiesRes, BaseErrorResponse>({
        path: '/api3/entity-info',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Entity
     * @name EntityControllerGetEntityInfo
     * @summary Returns information about entity
     * @request GET:/api3/entity-info/{name}
     * @secure
     * @response `200` `GetEntityInfoRes`
     * @response `400` `BaseErrorResponse`
     */
    entityControllerGetEntityInfo = (name: string, params: RequestParams = {}) =>
      this.request<GetEntityInfoRes, BaseErrorResponse>({
        path: `/api3/entity-info/${name}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new EntityInfo();
}
